import {
    convertCentsIntoDollar,
    formatDate,
} from "../../../helpers/genericHelper";

export const nestedColumns = [
    {
        title: "ID",
        dataIndex: "id",
        key: "id",
    },
    {
        title: "Category",
        dataIndex: "category",
        key: "category",
    },
    {
        title: "Mobile Brand Name",
        dataIndex: "mobileBrandName",
        key: "mobileBrandName",
    },
    {
        title: "Operating System Version",
        dataIndex: "osVersion",
        key: "osVersion",
    },
    {
        title: "Country",
        dataIndex: "country",
        key: "country",
    },
    {
        title: "Continent",
        dataIndex: "continent",
        key: "continent",
    },

    {
        title: "Time Zone Offset",
        dataIndex: "timeZoneOffset",
        key: "timeZoneOffset",
    },
];

export const mainColumns = [
    {
        title: "Date",
        dataIndex: "date",
        key: "date",
    },
    {
        title: "Mobile Model Name",
        dataIndex: "mobileModelName",
        key: "mobileModelName",
    },
    {
        title: "App Version",
        dataIndex: "version",
        key: "version",
    },
    {
        title: "City (IP Address)",
        dataIndex: "city",
        key: "city",
    },
    {
        title: "Region",
        dataIndex: "region",
        key: "region",
    },

    {
        title: "Min TS UTC",
        dataIndex: "minTsUTC",
        key: "minTsUTC",
        sorter: (a, b) => new Date(a.minTsUTC) - new Date(b.minTsUTC),
        defaultSortOrder: "descend",
        render: (val) => <p>{formatDate(val, true)}</p>
    },
    {
        title: "Max TS UTC",
        dataIndex: "maxTsUTC",
        key: "maxTsUTC",
        sorter: (a, b) => new Date(a.maxTsUTC) - new Date(b.maxTsUTC),
        render: (val) => <p>{formatDate(val, true)}</p>
    },

];